import { z } from 'zod';

export type VendorDashboardEventType = 'VendorDashboardTimeSpent';

// Vendor dashboard event payload schemas
export const VendorDashboardTimeSpentPayloadSchema = z.object({
  timeSpentSeconds: z.number(),
  url: z.string(),
  path: z.string(),
  timestamp: z.number(),
});

export type VendorDashboardEventTypePayloadMap = {
  VendorDashboardTimeSpent: z.infer<typeof VendorDashboardTimeSpentPayloadSchema>;
};

export const VendorDashboardEventSchemaMap = {
  VendorDashboardTimeSpent: VendorDashboardTimeSpentPayloadSchema,
};
